import { render, staticRenderFns } from "./StudentExamCard.vue?vue&type=template&id=2585c1a2&scoped=true&"
import script from "./StudentExamCard.vue?vue&type=script&lang=js&"
export * from "./StudentExamCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2585c1a2",
  null
  
)

export default component.exports